import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import StyledErrorMessage from '../StyledErrorMessage';
import Label from '../Label';

const RadioGroup = ({
  title, buttons, name, classes, required,
}) => (
  <>
    <div className={classes.group}>
      <div>
        <Label text={title} required={required} />
      </div>
      {buttons}
    </div>
    <StyledErrorMessage name={name} />
  </>
);

RadioGroup.defaultProps = {
  required: true,
};

RadioGroup.propTypes = {
  title: PropTypes.string.isRequired,
  buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  name: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  required: PropTypes.bool,
};

export default compose(
  injectSheet({
    group: {
      width: '100%',
      margin: '0 0 16px',
      padding: '0 8px',
    },
  }),
)(RadioGroup);
